import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";
import FounderCard from "../components/FounderCard";
import {
  brand,
  brandStory,
  whoWeAre,
  founderSpotlight,
  founders,
  exportMarkets,
  contact,
  agent,
} from "../data/siteData";
import "../styles/OurStory.css";

export default function OurStory() {
  return (
    <div className="tp-story">
      {/* <section className="tp-story-hero">
        <div className="tp-container">
          <span className="tp-eyebrow">{brand.since}</span>
          <h1 className="tp-section-heading">{brandStory.heading}</h1>
          <p className="tp-section-sub" style={{ margin: 0 }}>
            {brandStory.body}
          </p>
        </div>
      </section> */}

      <section className="tp-handicrafts-hero tp-floral-bg2">
        <div className="tp-container">
          <span className="tp-eyebrow">{founderSpotlight.eyebrow}</span>
          <h1 className="tp-section-heading">{founderSpotlight.heading}</h1>
          <p className="tp-section-sub">{brandStory.body}</p>
        </div>
      </section>

      {/* ---------------- Our Commitments ---------------- */}
      <section
        className="tp-section tp-section--tight tp-story-identity"
        id="certifications"
      >
        <div className="tp-container">
          <span
            className="tp-eyebrow"
            style={{ display: "block", textAlign: "center", marginBottom: 20 }}
          >
            Our Commitments
          </span>
          <div className="tp-story-identity__row">
            {whoWeAre.certifications.map((cert) => (
              <div className="tp-story-identity__item" key={cert}>
                <span>
                  <Icon name="checkCircle" size={22} />
                </span>
                <p>{cert}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- Founder Spotlight (cycles through founders) ---------------- */}
      <FounderCard
        founders={founders}
        eyebrow={founderSpotlight.eyebrow}
        sectionHeading={founderSpotlight.heading}
      />

      {/* ---------------- Trusted By Brands Across The Globe ---------------- */}
      <section className="tp-section tp-story-export">
        <div className="tp-container">
          <span className="tp-eyebrow">{exportMarkets.eyebrow}</span>
          <h2 className="tp-section-heading">{exportMarkets.heading}</h2>

          <div className="tp-story-export__grid">
            {exportMarkets.regions.map((region) => (
              <div className="tp-story-export__card" key={region.name}>
                <img
                  className="tp-story-export__flag"
                  src={region.flag}
                  alt={region.name}
                />
                <h4>{region.name}</h4>
                <p>{region.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- Contact strip ---------------- */}
      <section className="tp-section tp-story-contact">
        <div className="tp-section-agent">
          <div className="tp-container">
            <div className="tp-story-contact__card">
              <span className="tp-eyebrow">{agent.heading}</span>
              <h4>{agent.name}</h4>
              <p className="tp-story-contact__line">
                <Icon name="pin" size={15} />
                <span>{agent.altName}</span>
              </p>
              <p className="tp-story-contact__line">
                <Icon name="phone" size={15} />
                <span>{agent.phones.join(" · ")}</span>
              </p>
            </div>
          </div>
          <div className="tp-container">
            <div className="tp-story-contact__card">
              <span className="tp-eyebrow">Contact Us</span>
              <h4>{brand.name}</h4>
              <p className="tp-story-contact__line">
                <Icon name="mail" size={15} />
                <a href={`mailto:${contact.email}`}>{contact.email}</a>
              </p>
              <p className="tp-story-contact__line">
                <Icon name="pin" size={15} />
                <span>{contact.location}</span>
              </p>
              <Link
                to="/request-quote"
                className="tp-btn tp-btn--primary"
                style={{ marginTop: 18 }}
              >
                Request a Quote
                <Icon name="arrow" size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
